const CASHBACK_RETURN_MODAL = 'CASHBACK_RETURN_MODAL';
const STORE_NAME_KEY = 'STORE_NAME';

export function addAfterCashbackActivationModalStorage(storeName: string) {
  const currentValue = window.localStorage.getItem(CASHBACK_RETURN_MODAL);
  if (!currentValue) {
    window.localStorage.setItem(CASHBACK_RETURN_MODAL, 'true');
    window.localStorage.setItem(STORE_NAME_KEY, storeName);
  }
}

export function removeAfterCashbackActivationModalStorage() {
  window.localStorage.removeItem(CASHBACK_RETURN_MODAL);
  window.localStorage.removeItem(STORE_NAME_KEY);
}

export function getAfterCashbackActivationModalStorage() {
  if (typeof window !== 'undefined') {
    const modalValue = window.localStorage.getItem(CASHBACK_RETURN_MODAL);
    const storeName = window.localStorage.getItem(STORE_NAME_KEY);

    return {
      modalValue,
      storeName,
    };
  }
  return { modalValue: undefined, storeName: undefined };
}
